import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageGlowContainer from '../components/PageLayout';
import ProfessionalPage from '../components/ProfessionalPage';
import { techStackContent } from '../content/techStackContent';

const TechStack = ({ theme }) => {
  const navigate = useNavigate();

  if (theme === 'professional') {
    return (
      <ProfessionalPage title={techStackContent.title}>
        <p>{techStackContent.message}</p>
      </ProfessionalPage>
    );
  }

  return (
    <>
      <div className="ddr-grid"></div>
      <PageGlowContainer title={techStackContent.title} glowColor={techStackContent.glowColor} onEsc={() => navigate('/') }>
        <p className="text-lg text-white text-center font-sans">{techStackContent.message}</p>
      </PageGlowContainer>
    </>
  );
};

export default TechStack; 